import * as plotBandActions from '../../actions/plotBandActions';
import * as legendActions from '../../actions/legendActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './plotBands.utils';

const initialState = {
  mustRender: false,
  plotBands: [],
  plotBandPresets: [],
  showUkRecessions: false,
  showUsRecessions: false,
};

function plotBandsReducerReducer(state = initialState, action) {
  const { payload, stateTree } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case legendActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchPlotBandsInfo(state, action);
    case plotBandActions.UPDATE_PLOT_BANDS:
      return utils.updateChart(stateTree, state, payload, 'plotBands');
    case plotBandActions.UPDATE_PLOT_BAND_PRESETS:
      return utils.updateChart(stateTree, state, payload, 'plotBandPresets');
    case plotBandActions.UPDATE_SHOW_UK_RECESSIONS:
      return utils.updateChart(stateTree, state, payload, 'showUkRecessions');
    case plotBandActions.UPDATE_SHOW_US_RECESSIONS:
      return utils.updateChart(stateTree, state, payload, 'showUsRecessions');
    default:
      return state;
  }
}

export default plotBandsReducerReducer;
